import React,{useState,  useEffect } from 'react';
import { Grid, Typography } from '@mui/material';
import useTheme from '../../hooks/useTheme';
import PropTypes from 'prop-types';
import RecentSearchRow from './RecentSearchRow';
import {
	getSpecificString,
	replacePipeWithAnd,
} from '../../utils/breadCrumbUtils';
import {
	SideBarCollapseIcon,
	NavigateFwdIcon,
} from '../../assets/icons';
import { getGlobalApSearch } from '../../actions/accessPoint/accessPointList';
import { useDispatch } from 'react-redux';
import {
	BREADCRUMBS_URL,
    UPDATE_BREADCRUMBS_STATE
} from '../../constants/breadcrumbsConstant';
import { useNavigate } from 'react-router-dom';
import { encryptData,decryptData } from '../../utils/crypto';





const ApSearch = ({searchObj,handleFocusIn,setSearchObj,setSearchValue,searchValue,setMenuOpen, setIsFocused, apCount, resetPagination}) => {
	const { color, FontFace,} = useTheme();

    const [offsetValue, setOffsetValue] = useState(0);
	const dispatch = useDispatch();
	const [currentPage, setCurrentPage] = useState(1);
	const perPage = 4;
    const navigate = useNavigate();

	const maxPage = Math.ceil(apCount / perPage);
  
	const handlePreviousPage = (event) => {
		// event.stopPropagation();
		handleFocusIn();
		const newOffsetValue = Math.abs(offsetValue - perPage);
		setOffsetValue(newOffsetValue);
		setCurrentPage(Math.max(1, currentPage - 1));

		pageChange(perPage, newOffsetValue);
	};
	const pageChange = async (limit, calOffset) => {
		const response = await dispatch(
			getGlobalApSearch(limit, calOffset, null, searchValue)
		);
		if (response?.results?.length > 0) {
			setSearchObj(response.results);
		}
	};
    const updateBreadcrumbs = (payload) => ({
		type: UPDATE_BREADCRUMBS_STATE,
		payload: payload,
	});
    const updateBreadcrumbArray =  async (row) => {
        const selectedBreadcrumbs = row?.siteName
			.split('|')
			.reverse()
			.map((el, index, array) => {
				return {
					content: el,
					link: index === array?.length - 1 ? '/topology' : null,
					isCurrent: index === array.length - 1,
					type: 'group',
					group: getSpecificString(el, row?.siteName),
					res: replacePipeWithAnd(el, row?.siteName),
				};
			});
		const data = await dispatch(
			updateBreadcrumbs(
				BREADCRUMBS_URL.ACCESSPOINTDASHBOARD.concat(
					selectedBreadcrumbs
				).concat([
					{ content: row?.ap_name, link: '/access', isCurrent: true },
				])
			)
		);
        return data
    }
	const handleNextPage = () => {
		handleFocusIn();
		const newOffsetValue = Math.abs(offsetValue + perPage);
		setOffsetValue(newOffsetValue);
		setCurrentPage(Math.min(maxPage, currentPage + 1));
		pageChange(perPage, newOffsetValue);
	};

    const handleAccessPointClick = (item) => {
        console.log("item", item);
    
        let storedData = localStorage.getItem('recentlySearched');
        storedData = storedData ? JSON.parse(storedData) : {};
    
        if (!storedData['AccessPoint']) {
            storedData['AccessPoint'] = [];
        }
    
        const decryptedSerialNumbers = storedData['AccessPoint'].map(encrypted => decryptData(encrypted));
    
        if (!decryptedSerialNumbers.includes(item.serial_no)) {
            const encryptedSerialNo = encryptData(item.serial_no);
            storedData['AccessPoint'].push(encryptedSerialNo);
        }
    
        localStorage.setItem('recentlySearched', JSON.stringify(storedData));
    
        const newArray = updateBreadcrumbArray(item);
        console.log("newArray", newArray);
        
        navigate('/accessPointDashboard', {
            state: {
                breadcrumbs: newArray?.payload,
                row: item,
                siteId: null,
            },
        });
    
        setSearchValue('');
        setMenuOpen(false);
        setIsFocused(false);
    };
    
    


    // useEffect removed - count is now passed as prop from parent

    // Reset pagination when resetPagination prop changes
    useEffect(() => {
        if (resetPagination) {
            setCurrentPage(1);
            setOffsetValue(0);
        }
    }, [resetPagination]);

    return (
        <Grid >
            {  searchValue && searchObj?.length > 0 &&   (
                <Grid
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        margin: '10px',
                        
                    }}
                >
                    <Typography
                        style={{
                            color: color.text.primary,
                            fontSize:
                                FontFace.font_size
                                    .input_text,
                            fontFamily: 'Inter-SemiBold',
                        }}
                    >
                        AP
                    </Typography>
                    <Grid
                        sx={{
                            display: 'flex',
                            flexDirection: 'row',
                             marginTop:"3px"
                        }}
                    >
                        <Typography
                            variant="h6"
                            style={{
                                color: color.text.primary,
                                fontSize: "12px",
                                fontFamily: 'Inter-SemiBold',
                                marginTop: "-2.5px"
                            }}
                        >
                            {'('} Showing {' '}
                            {Math.min((currentPage - 1) * perPage + 1, apCount)} to{' '}
                            {Math.min(currentPage * perPage, apCount)} of{' '}
                            {apCount} entries {')'} {' '} {' '}  page : {currentPage}
                        </Typography>

                        <div
                            onMouseDown={currentPage === 1 ? null : handlePreviousPage}
                        >
                            <SideBarCollapseIcon
                                width={'16px'}
                                height={'16px'}
                            />
                        </div>
                        <div onMouseDown={Math.min(currentPage * perPage, apCount) === apCount ? null : handleNextPage}>
                            <NavigateFwdIcon
                                width={'16px'}
                                height={'16px'}
                            />
                        </div>
                    </Grid>
                    
                </Grid>
            )}
            { searchValue && searchObj?.length > 0 &&
                searchObj?.map((obj, index) => (
                    <RecentSearchRow
                        type="search"
                        key={index}
                        index={index}
                        item={obj?.serial_no}
                        // handleBookmark={handleBookmark}
                        color={color}
                        FontFace={FontFace}
                        onClick={() => {
                            handleAccessPointClick(obj);
                        }}
                    />
                ))}
        </Grid>
    );
};
ApSearch.propTypes = {
	searchObj: PropTypes.string.isRequired,
    handleFocusIn: PropTypes.func.isRequired,
    setSearchObj:PropTypes.func.isRequired,
    searchValue: PropTypes.string.isRequired,
    setSearchValue: PropTypes.func,
    setIsSearched: PropTypes.func,
    setMenuOpen: PropTypes.func,
    setIsFocused: PropTypes.func,
    apCount: PropTypes.number,
    resetPagination: PropTypes.bool,
};
export default ApSearch;
